import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type MergeContainerConfigMutationVariables = Types.Exact<{
  input: Types.MergeContainerConfigInput;
}>;


export type MergeContainerConfigMutation = { __typename?: 'Mutation', mergeContainerConfig: { __typename?: 'ContainerConfigPayload', containerConfig?: { __typename?: 'ContainerConfigStateData', containerConfigId: string, categoryCode: string, containerCode: string, containerName: string, siteCodes: Array<string>, parentContainerConfigId?: string | null, sizeUomCode: string, height: number, width: number, depth: number, weight?: number | null, weightUnit: Types.WeightUnit, maxTraysPerLayer: number, maxLayersPerContainer: number, shipFactor: number, shipMinimum: number, status: Types.ContainerConfigStatus, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type UpdateContainerConfigDetailsMutationVariables = Types.Exact<{
  input: Types.UpdateContainerConfigDetailsInput;
}>;


export type UpdateContainerConfigDetailsMutation = { __typename?: 'Mutation', updateContainerConfigDetails: { __typename?: 'ContainerConfigPayload', containerConfig?: { __typename?: 'ContainerConfigStateData', containerConfigId: string, categoryCode: string, containerCode: string, containerName: string, siteCodes: Array<string>, parentContainerConfigId?: string | null, sizeUomCode: string, height: number, width: number, depth: number, weight?: number | null, weightUnit: Types.WeightUnit, maxTraysPerLayer: number, maxLayersPerContainer: number, shipFactor: number, shipMinimum: number, status: Types.ContainerConfigStatus, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type DeactivateContainerConfigMutationVariables = Types.Exact<{
  input: Types.DeactivateContainerConfigInput;
}>;


export type DeactivateContainerConfigMutation = { __typename?: 'Mutation', deactivateContainerConfig: { __typename?: 'ContainerConfigPayload', containerConfig?: { __typename?: 'ContainerConfigStateData', containerConfigId: string, categoryCode: string, containerCode: string, containerName: string, siteCodes: Array<string>, parentContainerConfigId?: string | null, sizeUomCode: string, height: number, width: number, depth: number, weight?: number | null, weightUnit: Types.WeightUnit, maxTraysPerLayer: number, maxLayersPerContainer: number, shipFactor: number, shipMinimum: number, status: Types.ContainerConfigStatus, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type ActivateContainerConfigMutationVariables = Types.Exact<{
  input: Types.ActivateContainerConfigInput;
}>;


export type ActivateContainerConfigMutation = { __typename?: 'Mutation', activateContainerConfig: { __typename?: 'ContainerConfigPayload', containerConfig?: { __typename?: 'ContainerConfigStateData', containerConfigId: string, categoryCode: string, containerCode: string, containerName: string, siteCodes: Array<string>, parentContainerConfigId?: string | null, sizeUomCode: string, height: number, width: number, depth: number, weight?: number | null, weightUnit: Types.WeightUnit, maxTraysPerLayer: number, maxLayersPerContainer: number, shipFactor: number, shipMinimum: number, status: Types.ContainerConfigStatus, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type ContainerConfigStateFragment = { __typename?: 'ContainerConfigStateData', containerConfigId: string, categoryCode: string, containerCode: string, containerName: string, siteCodes: Array<string>, parentContainerConfigId?: string | null, sizeUomCode: string, height: number, width: number, depth: number, weight?: number | null, weightUnit: Types.WeightUnit, maxTraysPerLayer: number, maxLayersPerContainer: number, shipFactor: number, shipMinimum: number, status: Types.ContainerConfigStatus, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string };

export const ContainerConfigStateFragmentDoc = new TypedDocumentString(`
    fragment ContainerConfigState on ContainerConfigStateData {
  containerConfigId
  categoryCode
  containerCode
  containerName
  siteCodes
  parentContainerConfigId
  sizeUomCode
  height
  width
  depth
  weight
  weightUnit
  maxTraysPerLayer
  maxLayersPerContainer
  shipFactor
  shipMinimum
  status
  createdAt
  createdBy
  updatedAt
  updatedBy
}
    `, {"fragmentName":"ContainerConfigState"});
export const MergeContainerConfigDocument = new TypedDocumentString(`
    mutation MergeContainerConfig($input: MergeContainerConfigInput!) {
  mergeContainerConfig(input: $input) {
    containerConfig {
      ...ContainerConfigState
    }
    errors {
      code
      message
    }
  }
}
    fragment ContainerConfigState on ContainerConfigStateData {
  containerConfigId
  categoryCode
  containerCode
  containerName
  siteCodes
  parentContainerConfigId
  sizeUomCode
  height
  width
  depth
  weight
  weightUnit
  maxTraysPerLayer
  maxLayersPerContainer
  shipFactor
  shipMinimum
  status
  createdAt
  createdBy
  updatedAt
  updatedBy
}`);
export const UpdateContainerConfigDetailsDocument = new TypedDocumentString(`
    mutation UpdateContainerConfigDetails($input: UpdateContainerConfigDetailsInput!) {
  updateContainerConfigDetails(input: $input) {
    containerConfig {
      ...ContainerConfigState
    }
    errors {
      code
      message
    }
  }
}
    fragment ContainerConfigState on ContainerConfigStateData {
  containerConfigId
  categoryCode
  containerCode
  containerName
  siteCodes
  parentContainerConfigId
  sizeUomCode
  height
  width
  depth
  weight
  weightUnit
  maxTraysPerLayer
  maxLayersPerContainer
  shipFactor
  shipMinimum
  status
  createdAt
  createdBy
  updatedAt
  updatedBy
}`);
export const DeactivateContainerConfigDocument = new TypedDocumentString(`
    mutation DeactivateContainerConfig($input: DeactivateContainerConfigInput!) {
  deactivateContainerConfig(input: $input) {
    containerConfig {
      ...ContainerConfigState
    }
    errors {
      code
      message
    }
  }
}
    fragment ContainerConfigState on ContainerConfigStateData {
  containerConfigId
  categoryCode
  containerCode
  containerName
  siteCodes
  parentContainerConfigId
  sizeUomCode
  height
  width
  depth
  weight
  weightUnit
  maxTraysPerLayer
  maxLayersPerContainer
  shipFactor
  shipMinimum
  status
  createdAt
  createdBy
  updatedAt
  updatedBy
}`);
export const ActivateContainerConfigDocument = new TypedDocumentString(`
    mutation ActivateContainerConfig($input: ActivateContainerConfigInput!) {
  activateContainerConfig(input: $input) {
    containerConfig {
      ...ContainerConfigState
    }
    errors {
      code
      message
    }
  }
}
    fragment ContainerConfigState on ContainerConfigStateData {
  containerConfigId
  categoryCode
  containerCode
  containerName
  siteCodes
  parentContainerConfigId
  sizeUomCode
  height
  width
  depth
  weight
  weightUnit
  maxTraysPerLayer
  maxLayersPerContainer
  shipFactor
  shipMinimum
  status
  createdAt
  createdBy
  updatedAt
  updatedBy
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    MergeContainerConfig: build.mutation<MergeContainerConfigMutation, MergeContainerConfigMutationVariables>({
      query: (variables) => ({ document: MergeContainerConfigDocument, variables })
    }),
    UpdateContainerConfigDetails: build.mutation<UpdateContainerConfigDetailsMutation, UpdateContainerConfigDetailsMutationVariables>({
      query: (variables) => ({ document: UpdateContainerConfigDetailsDocument, variables })
    }),
    DeactivateContainerConfig: build.mutation<DeactivateContainerConfigMutation, DeactivateContainerConfigMutationVariables>({
      query: (variables) => ({ document: DeactivateContainerConfigDocument, variables })
    }),
    ActivateContainerConfig: build.mutation<ActivateContainerConfigMutation, ActivateContainerConfigMutationVariables>({
      query: (variables) => ({ document: ActivateContainerConfigDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useMergeContainerConfigMutation, useUpdateContainerConfigDetailsMutation, useDeactivateContainerConfigMutation, useActivateContainerConfigMutation } = injectedRtkApi;
